import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";
import { fecha } from "../lib/formato";
import { useIdioma } from "../lib/idioma";

/**
 * La cinta que avisa de cómo va la suscripción del club.
 *
 * Está arriba del todo y en todas las pantallas a propósito. El club no puede
 * enterarse de que se le acaba la prueba el día que deja de poder trabajar: eso
 * no es una limitación del programa, es una emboscada.
 *
 * Mientras falte más de una semana no sale nada. Un cartel permanente es un
 * cartel que se deja de ver, y entonces no sirve el día que importa.
 */

export interface EstadoSuscripcion {
  estado: string;
  hasta: string | null;
  diasRestantes: number | null;
  diasDeRetraso: number;
  enGracia: boolean;
  bloqueado: boolean;
  avisar: boolean;
}

export default function AvisoSuscripcion() {
  const { t, dias: enDias } = useIdioma();
  const suscripcion = useQuery({
    queryKey: ["suscripcion"],
    queryFn: () => api<EstadoSuscripcion>("/club/suscripcion"),
    // Cada media hora: esto cambia de un día para otro, no de un clic a otro.
    staleTime: 30 * 60 * 1000,
  });

  const s = suscripcion.data;
  if (!s?.avisar) return null;

  if (s.bloqueado) {
    return (
      <div className="cinta-suscripcion bloqueada">
        <strong>{t("as.soloLectura")}</strong> {t("as.llevaSinRegularizar", { dias: enDias(s.diasDeRetraso) })}
      </div>
    );
  }

  if (s.enGracia) {
    return (
      <div className="cinta-suscripcion vencida">
        <strong>
          {s.diasDeRetraso === 1 ? t("as.vencioAyer") : t("as.vencioHace", { dias: enDias(s.diasDeRetraso) })}
        </strong>{" "}
        {t("as.siSigue")}
      </div>
    );
  }

  const quedan = s.diasRestantes ?? 0;
  // El parentesis con la fecha va dentro de la frase, que cada idioma la ordena
  // a su manera; si no hay fecha el hueco se queda vacio y la frase sigue bien.
  const cuando = s.hasta ? t("as.entreParentesis", { fecha: fecha(s.hasta) }) : "";
  return (
    <div className="cinta-suscripcion pronto">
      {quedan <= 0
        ? t("as.venceHoy", { fecha: cuando })
        : quedan === 1
          ? t("as.venceManana", { fecha: cuando })
          : t("as.venceEn", { dias: enDias(quedan), fecha: cuando })}{" "}
      {t("as.noHayQueHacer")}
    </div>
  );
}
